module.exports = __webpack_public_path__ + "media/images/member-database-1-b1f1adc922a5e2f0515ff5e39700aa34.svg";